export enum EntityType {
  site = 'SITE',
  department = 'DEPARTMENT',
  resource = 'RESOURCE',
  vendor = 'VENDOR',
  productAndService = 'PRODUCT_AND_SERVICE',
  user = 'USER',
  role = 'ROLE'
}
